<template>
  <span v-if="message != null">
    <i
      class=" icon d-flex position-relative tooltip"
      :class="icon + ' text-' + iconColor"
      :id="computedTooltipTarget"
    ></i>
    <b-tooltip
      :target="computedTooltipTarget"
      triggers="hover"
      :variant="tooltipBodyColor"
    >
      {{ message }}
    </b-tooltip>
  </span>
</template>
<script>
/**
 * @description Composante servant à afficher de l'information dans un tooltip
 * @author Francine Jin
 * vue-prop {String} identifier - Identifiant de l'input
 * vue-prop {String} message - L'information à afficher
 * vue-prop {String} icon - Le nom de l'icône
 * vue-prop {String} tooltipBodyColor - La couleur du conteneur/tooltip
 * vue-prop {String} iconColor - La couleur de l'icône
 * vue-computed {String} computedTooltipTarget - Méthode qui retourne la bonne cible pour le tooltip
 */
export default {
  name: "TooltipInformation",
  props: {
    identifier: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: false,
      default: ""
    },
    icon: {
      type: String,
      required: false,
      default: "question circle outline"
    },
    tooltipBodyColor: {
      type: String,
      required: false,
      default: "info"
    },
    iconColor: {
      type: String
    }
  },
  computed: {
    computedTooltipTarget() {
      return this.identifier + "-tooltip-" + Math.random() * 20;
    }
  }
};
</script>

<style scoped>
.tooltip {
  cursor: pointer;
}
</style>
